export var providerVariables = function providerVariables(siteVariables) {
  return {
    scrollbarThumbBackgroundColor: siteVariables.colors.white,
    scrollbarThumbHoverBackgroundColor: siteVariables.colors.white
  };
};
//# sourceMappingURL=providerVariables.js.map
